/**
 * DECLARATION DE FUNCTIONS
 */

(function ($) {
   $.fn.fancybox_images = function (params) {
      this.each(function () {
         $("a[href$='.jpg'], a[href$='.png'], a[href$='.jpeg'], a[href$='.gif'], a[href$='.svg']").fancybox({
            keyboard: true,
            loop: false,
            arrows: true,
            infobar: false,
            afterLoad: function (instance, current) {
               var pixelRatio = window.devicePixelRatio || 1;
               
               if (pixelRatio > 1.5) {
                  current.width = current.width / pixelRatio;
                  current.height = current.height / pixelRatio;
               }
            }
         });
      });
   };
})(jQuery)

/**
 * DOM
 */
jQuery(document).ready(function ($) {
   /**
    * FUNCTIONS
    */
   $('body').fancybox_images();
   
   /**
    * ANIMATIONS
    */
   //wow
   new WOW({
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
   }).init();
   
   /**
    * scroll on click
    */
   $('a[href^="#"]').on('click', function (event) {
      event.preventDefault();
      var target = this.hash;
      $('html, body').animate({scrollTop: $(target).offset().top - 150}, 400);
   });
   
   /**
    * document load
    */
   $(window).load(function () {
      //bxslider
      $('.slider').each(function () {
         var ul = $(this);
         var count = $(this).children().length;
         
         if (count > 1) {
            ul.bxSlider({
               nextText: '<i class="fa-light fa-arrow-right-to-line"></i>',
               prevText: '<i class="fa-light fa-arrow-left-to-line"></i>',
               pager: false,
               auto: true,
               pause: 4000,
               autoHover: true
            });
         }
      });
      
      $('.sliderLogo').each(function () {
         
         if ($(window).width() < 550) {
            r_largeur = 1;
         } else if ($(window).width() >= 550 && $(window).width() < 750) {
            r_largeur = 3;
         } else {
            r_largeur = 5;
         }
         
         var ul = $(this);
         var count = $(this).children().length;
         
         if (count > 1) {
            ul.bxSlider({
               controls: false,
               pager: false,
               auto: true,
               pause: 4000,
               autoHover: false,
               minSlides: r_largeur,
               maxSlides: r_largeur,
               moveSlides: 1,
               speed: 1500,
               slideWidth: 3000,
            });
         }
      });
      
      $('.carouselCitations').each(function () {
         var ul = $(this);
         var count = $(this).children().length;
         
         if (count > 1) {
            
            var carouselTemoignages = ul.bxSlider({
               mode: 'horizontal',
               startSlide: 0,
               speed: 1000,
               controls: false,
               pager: true,
               auto: true,
               pause: 5000,
            });
            
         }
      });      
      
      //nav mobile foldable
      $('nav.mobile .menu-item-has-children > a').on('click', function (e) {
         e.preventDefault();
         $(this).next("ul").slideToggle();
         $(this).toggleClass("open");
      });
   });
   
});

var StackCards = function (element) {
   this.element = element;
   this.items = this.element.getElementsByClassName('stack-card-item');
   this.scrollingFn = false;
   this.scrolling = false;
   initStackCardsEffect(this);
   initStackCardsResize(this);
};

function initStackCardsEffect(element) { // use Intersection Observer to trigger animation
   setStackCards(element); // store cards CSS properties
   var observer = new IntersectionObserver(stackCardsCallback.bind(element), {threshold: [0, 1]});
   observer.observe(element.element);
};

function initStackCardsResize(element) { // detect resize to reset gallery
   element.element.addEventListener('resize-stack-cards', function () {
      setStackCards(element);
      animateStackCards.bind(element);
   });
};

function stackCardsCallback(entries) { // Intersection Observer callback
   if (entries[0].isIntersecting) {
      if (this.scrollingFn) return; // listener for scroll event already added
      stackCardsInitEvent(this);
   } else {
      if (!this.scrollingFn) return; // listener for scroll event already removed
      window.removeEventListener('scroll', this.scrollingFn);
      this.scrollingFn = false;
   }
};

function stackCardsInitEvent(element) {
   element.scrollingFn = stackCardsScrolling.bind(element);
   window.addEventListener('scroll', element.scrollingFn);
};

function stackCardsScrolling() {
   if (this.scrolling) return;
   this.scrolling = true;
   window.requestAnimationFrame(animateStackCards.bind(this));
};

function setStackCards(element) {
   // store wrapper properties
   element.marginY = getComputedStyle(element.element).getPropertyValue('--stack-cards-gap');
   getIntegerFromProperty(element); // convert element.marginY to integer (px value)
   element.elementHeight = element.element.offsetHeight;

   // store card properties
   var cardStyle = getComputedStyle(element.items[0]);
   element.cardTop = Math.floor(parseFloat(cardStyle.getPropertyValue('top')));
   element.cardHeight = Math.floor(parseFloat(cardStyle.getPropertyValue('height')));

   // store window property
   element.windowHeight = window.innerHeight;

   // reset margin + translate values
   if (isNaN(element.marginY)) {
      element.element.style.paddingBottom = '0px';
   } else {
      element.element.style.paddingBottom = (element.marginY * (element.items.length - 1)) + 'px';
   }

   for (var i = 0; i < element.items.length; i++) {
      if (isNaN(element.marginY)) {
         element.items[i].style.transform = 'none;';
      } else {
         element.items[i].style.transform = 'translateY(' + element.marginY * i + 'px)';
      }
   }
};

function getIntegerFromProperty(element) {
   var node = document.createElement('div');
   node.setAttribute('style', 'opacity:0; visbility: hidden;position: absolute; height:' + element.marginY);
   element.element.appendChild(node);
   element.marginY = parseInt(getComputedStyle(node).getPropertyValue('height'));
   element.element.removeChild(node);
};

function animateStackCards() {
   if (isNaN(this.marginY)) { // --stack-cards-gap not defined - do not trigger the effect
      this.scrolling = false;
      return;
   }

   var top = this.element.getBoundingClientRect().top;

   if (this.cardTop - top + this.element.windowHeight - this.elementHeight - this.cardHeight + this.marginY + this.marginY * this.items.length > 0) {
      this.scrolling = false;
      return;
   }

   for (var i = 0; i < this.items.length; i++) { // use only scale
      var scrolling = this.cardTop - top - i * (this.cardHeight + this.marginY);
      if (scrolling > 0) {
         var scaling = i == this.items.length - 1 ? 1 : (this.cardHeight - scrolling * 0.01) / this.cardHeight;
         this.items[i].style.transform = 'translateY(' + this.marginY * i + 'px) scale(' + scaling + ')';
      } else {
         this.items[i].style.transform = 'translateY(' + this.marginY * i + 'px)';
      }
   }

   this.scrolling = false;
};

// initialize StackCards object
var stackCards = document.getElementsByClassName('stack-card-container'),
    intersectionObserverSupported = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype),
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (stackCards.length > 0 && intersectionObserverSupported && !reducedMotion) {
   var stackCardsArray = [];
   for (var i = 0; i < stackCards.length; i++) {
      (function (i) {
         stackCardsArray.push(new StackCards(stackCards[i]));
      })(i);
   }

   var resizingId = false,
       customEvent = new CustomEvent('resize-stack-cards');

   window.addEventListener('resize', function () {
      clearTimeout(resizingId);
      resizingId = setTimeout(doneResizing, 500);
   });

   function doneResizing() {
      for (var i = 0; i < stackCardsArray.length; i++) {
         (function (i) {
            stackCardsArray[i].element.dispatchEvent(customEvent)
         })(i);
      }
      ;
   };
}
;
